import { motion } from 'framer-motion';

const steps = ['Intent', 'Evidence', 'Accountability'];

export function TrustLoop() {
  const radius = 92;
  return (
    <div className="relative mx-auto aspect-square w-full max-w-[280px]">
      <svg viewBox="0 0 240 240" className="absolute inset-0 h-full w-full -rotate-90">
        <circle cx="120" cy="120" r={radius} fill="none" stroke="rgba(34,211,238,0.15)" strokeWidth="2" />
        <motion.circle
          cx="120" cy="120" r={radius}
          fill="none" stroke="#22d3ee" strokeWidth="3" strokeLinecap="round"
          strokeDasharray={2 * Math.PI * radius}
          initial={{ strokeDashoffset: 2 * Math.PI * radius }}
          whileInView={{ strokeDashoffset: 0 }}
          viewport={{ once: true }}
          transition={{ duration: 1.6, ease: 'easeInOut' }}
        />
      </svg>
      <motion.div
        className="absolute inset-0"
        animate={{ rotate: 360 }}
        transition={{ duration: 12, repeat: Infinity, ease: 'linear' }}
      >
        <div className="absolute left-1/2 top-[calc(50%-92px)] h-3 w-3 -translate-x-1/2 rounded-full bg-cyan-400 shadow-[0_0_12px_rgba(34,211,238,0.9)]" />
      </motion.div>
      {steps.map((s, i) => {
        const angle = (i / steps.length) * Math.PI * 2 - Math.PI / 2;
        const x = Math.cos(angle) * radius;
        const y = Math.sin(angle) * radius;
        return (
          <div
            key={s}
            className="absolute left-1/2 top-1/2 -translate-x-1/2 -translate-y-1/2 whitespace-nowrap rounded-md border border-cyan-500/20 bg-[#0b1030]/90 px-2.5 py-1 text-cyan-100/90"
            style={{ marginLeft: x, marginTop: y }}
          >
            {s}
          </div>
        );
      })}
      <div className="absolute left-1/2 top-1/2 -translate-x-1/2 -translate-y-1/2 text-center text-cyan-200">
        HumAIn<br />trust
      </div>
    </div>
  );
}
